import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/pages/index'], resolve)
    },
    // {
    //   path: '/demo',
    //   name: 'demo',
    //   component: resolve => require(['@/pages/demo'], resolve)
    // },
    {
      path: '/forget',
      name: 'forget',
      component: resolve => require(['@/pages/forget'], resolve)
    },
    {
      path: '/adminVideo',
      name: 'adminVideo',
      component: resolve => require(['@/pages/adminVideo'], resolve)
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: resolve => require(['@/pages/myOrder'], resolve)
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: resolve => require(['@/pages/orderDetail'], resolve)
    },
    {
      path: '/carOrder',
      name: 'carOrder',
      component: resolve => require(['@/pages/carOrder'], resolve)
    },
    {
      path: '/driverOrder',
      name: 'driverOrder',
      component: resolve => require(['@/pages/driverOrder'], resolve)
    },
    {
      path: '/reserve',
      name: 'Reserve',
      component: resolve => require(['@/pages/reserve'], resolve)
    },
    {
      path: '/register/:tab?',
      name: 'Register',
      component: resolve => require(['@/pages/register'], resolve)
    },
    {
      path: '/logistics',
      name: 'Logistics',
      component: resolve => require(['@/pages/transport'], resolve)
    },
    {
      path: '/bussiness',
      name: 'Bussiness',
      component: resolve => require(['@/pages/bussiness'], resolve)
    },
    {
      path: '/about',
      name: 'About',
      component: resolve => require(['@/pages/about'], resolve)
    },
    {
      path: '/news',
      name: 'News',
      component: resolve => require(['@/pages/news'], resolve)
    },
    {
      path: '/culture',
      name: 'Culture',
      component: resolve => require(['@/pages/culture'], resolve)
    },
    {
      path: '/join',
      name: 'Join',
      component: resolve => require(['@/pages/join'], resolve)
    },
    // 核心业务详情
    {
      path: '/detail/:id?/:banner?/:title?',
      name: 'detail',
      component: resolve => require(['@/pages/detail'], resolve)
    },
    // 新闻详情
    {
      path: '/article/:id?',
      name: 'article',
      component: resolve => require(['@/pages/article'], resolve)
    },
    // 企业文化详情
    {
      path: '/content/:id?',
      name: 'content',
      component: resolve => require(['@/pages/content'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js